import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { ModalComponent } from './modal/modal.component';
import { ClarityModule, ClrIconModule } from '@clr/angular';

@NgModule({
  declarations: [TableComponent, ModalComponent],
  imports: [CommonModule, ClarityModule, ClrIconModule],
  exports: [TableComponent, ModalComponent]
})
export class UIKitModule {}
